<template>
    <div id="left-sidebar-tabs">
        <span data-container="blocks" class="selected" :class="{ '--disabled': !canUseColorGradingTools }"> Tools</span>
        <span data-container="compares" class="ml-12">
            Selections
		</span>
        <div class="d-flex align-center">
            <CandidateCounter />
            <i @click="openCompareView" class="material-icons ml-2"
               :class="{'--disabled': !getAllCandidates.length}"
               data-tippy-content="View Selections">visibility</i>
        </div>

        <div class="selector-slider"></div>
    </div>
</template>

<script>
import CandidateCounter from '@/components/app/assets/CandidateCounter';
import CanMixin from '@/mixins/CanMixin';
import { mapGetters } from 'vuex';

export default {
    mixins: [CanMixin],
    components: {
        CandidateCounter,
    },
    computed: {
        ...mapGetters('File/Candidates', ['getAllCandidates']),
    },

    methods: {
        async openCompareView() {
            let selectedFiles = this.getAllCandidates;
            if (selectedFiles.length == 0) return;

            this.$store.commit('UI/RESET_COMPARE_VIEW');
            UI.showModal(UI.modals.compareView.el);

            for await (const selectedFile of selectedFiles) {
                this.$store.commit('UI/ADD_LOADING_ASSET_TO_COMPARE_VIEW');

                let storeData;
                storeData = await lutify.fetchCandidate(selectedFile);
                if (!storeData.image) storeData.image = await lutify.fetchCandidateImage(selectedFile);

                storeData.tags = selectedFile.tags;
                storeData.loaded = true;
                storeData.assetObject = selectedFile;

                this.$store.commit('UI/ADD_ASSET_TO_COMPARE_VIEW', storeData);
            }
        },
    }
};
</script>

<style lang="scss" scoped>
#left-sidebar-tabs {
	display: grid;
	grid-template-columns: repeat(3, auto);
	justify-content: center;
	align-items: center;
	padding: 2px 12px 0;
	height: var(--sidebar-tabs-height);
	position: relative;
	margin-bottom: 10px;

    i {
		cursor: pointer;
		font-size: 18px;

		&.--disabled {
			opacity: .3;
			cursor: not-allowed;
		}
	}

	> span {
		position: relative;
		cursor: pointer;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		transition: all 0.05s ease;
		text-transform: uppercase;
		font-size: 12px;
		font-weight: bold;
		line-height: 18px;

		&:last-of-type {
			margin-right: 15px;
		}
	}

	> .selected {
		color: #fff;
	}

	.selector-slider {
		width: 65px;
		position: absolute;
		bottom: -1px;
		left: 0;
		transform: translateX(12px);
		background: var(--primary);
		height: 2px;
		transition: all 0.05s ease;
	}
}
</style>
